module.exports = __webpack_public_path__ + "static/media/11.b3f7389c.jpg";